import { LayerReview } from 'models/guide';

const MOCK_LAYER_REVIEW: LayerReview = {
    comments: [
        {
            id: '6125ca7c046f9001a5d5ab56',
            userId: '903419ec-6ae3-45e9-837a-24315f8a39ea',
            upVotes: 5,
            downVotes: 2,
            userName: 'Owen Cox',
            text: 'Elit deserunt cupidatat esse veniam mollit nisi sunt.',
            replies: [
                {
                    id: '6125ca7ca67b278e09b5b93c',
                    parentId: '6125ca7c046f9001a5d5ab56',
                    userId: '67d346e7-591e-44dc-84e9-d667336f0d37',
                    upVotes: 8,
                    downVotes: 6,
                    userName: 'Irwin Mcneil',
                    text: 'Aliquip proident elit commodo labore exercitation esse ipsum in non duis ad officia.',
                    replies: [
                        {
                            id: '6125ca7c038783acb760a8a0',
                            parentId: '6125ca7ca67b278e09b5b93c',
                            userId: 'c8bbc6de-2fc9-4566-885e-eb0e02b2a5b2',
                            upVotes: 8,
                            downVotes: 9,
                            userName: 'Ruiz Chang',
                            text: 'Qui incididunt amet dolor anim cupidatat do officia eiusmod.',
                            replies: [
                                {
                                    id: '6125ca7cd75c66e56064bccd',
                                    parentId: '6125ca7c038783acb760a8a0',
                                    userId: '26cc95e5-c655-439c-87f3-8537def92a61',
                                    upVotes: 1,
                                    downVotes: 3,
                                    userName: 'Collins Black',
                                    text: 'Voluptate cillum ullamco proident fugiat sunt.',
                                    replies: [],
                                },
                                {
                                    id: '6125ca7cd75c66e44444bccd',
                                    parentId: '6125ca7c038783acb760a8a0',
                                    userId: '26cc95e5-c655-4444-87f3-8537def92a61',
                                    upVotes: 4,
                                    downVotes: 4,
                                    userName: 'John Smith',
                                    text: 'hello world',
                                    replies: [],
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: '6125ca7c2c876bacc5952779',
            userId: '72ca4e9d-2669-4d46-a399-cde614c0f17c',
            upVotes: 9,
            downVotes: 7,
            userName: 'Hallie Barr',
            text: 'Dolore commodo mollit ea minim qui consectetur Lorem.',
            replies: [],
        },
        {
            id: '6125ca7c2b80a6573fdfe233',
            userId: 'b2b4fed0-ec12-46d0-8daf-7fd415d0fef4',
            upVotes: 10,
            downVotes: 9,
            userName: 'Clements Pickett',
            text: 'Cupidatat exercitation duis dolor minim duis aliqua reprehenderit sint incididunt ut culpa culpa.',
            replies: [],
        },
        {
            id: '6125ca7c70d7bab1fb872f76',
            userId: '4949bcc3-fc57-4342-8c35-32afc4d77858',
            upVotes: 8,
            downVotes: 0,
            userName: 'Viola Cash',
            text: 'Proident dolor nulla aliqua eu sit occaecat consequat.',
            replies: [],
        },
        {
            id: '6125ca7c40fe1aeb8127cd05',
            userId: '7d8578c1-58ae-4df4-a1df-145a5f66cb5a',
            upVotes: 5,
            downVotes: 6,
            userName: 'Nash Fitzgerald',
            text: 'Nulla ut occaecat officia irure labore tempor dolor sint qui nostrud sunt adipisicing.',
            replies: [
                {
                    id: '6125ca7c82e849e94de92be5',
                    parentId: '6125ca7c40fe1aeb8127cd05',
                    userId: '29576f3a-739b-474a-97a4-bc79cd25309f',
                    upVotes: 9,
                    downVotes: 1,
                    userName: 'Gilbert Barlow',
                    text: 'Consequat culpa est consectetur pariatur irure enim do.',
                    replies: [
                        {
                            id: '6125ca7ca515b960b6e19ca5',
                            parentId: '6125ca7c82e849e94de92be5',
                            userId: 'bc7132d4-3203-4a84-b904-745d05848d9d',
                            upVotes: 7,
                            downVotes: 8,
                            userName: 'Eva Berg',
                            text: 'Nostrud commodo mollit aliqua ipsum magna consequat.',
                            replies: [],
                        },
                    ],
                },
            ],
        },
        {
            id: '6125ca7c9511673743b48c40',
            userId: 'fe60fb2b-e426-4351-944f-084c36500244',
            upVotes: 6,
            downVotes: 9,
            userName: 'Parsons Alston',
            text: 'Enim proident eu irure adipisicing sint irure laboris aliqua qui adipisicing aute incididunt.',
            replies: [],
        },
        {
            id: '6125ca7ce436fab2d15509d3',
            userId: 'abba88f8-e36c-4e4d-969d-a0d213980a7c',
            upVotes: 3,
            downVotes: 3,
            userName: 'Lourdes Nicholson',
            text: 'Elit anim pariatur laborum Lorem excepteur culpa nisi aute id eu et aute anim exercitation.',
            replies: [
                {
                    id: '6125ca7c3137afa46ec285b1',
                    parentId: '6125ca7ce436fab2d15509d3',
                    userId: '4032503d-7188-46d0-87b9-41045e65b4fa',
                    upVotes: 9,
                    downVotes: 3,
                    userName: 'Zelma Rich',
                    text: 'Aliqua reprehenderit dolor duis anim consectetur enim commodo nostrud tempor reprehenderit cupidatat veniam pariatur.',
                    replies: [],
                },
                {
                    id: '6125ca7c1dca75e6432af708',
                    parentId: '6125ca7ce436fab2d15509d3',
                    userId: 'f78f6905-7887-450f-8664-2b7c736b919c',
                    upVotes: 7,
                    downVotes: 8,
                    userName: 'Freeman Wiley',
                    text: 'Velit mollit qui est commodo aliqua adipisicing.',
                    replies: [],
                },
                {
                    id: '6125ca7cef17771e1cca6d5e',
                    parentId: '6125ca7ce436fab2d15509d3',
                    userId: 'cc3a9930-7e72-4c75-9151-34000149c5c8',
                    upVotes: 7,
                    downVotes: 5,
                    userName: 'Barrett Gibbs',
                    text: 'Adipisicing anim esse mollit ad pariatur.',
                    replies: [],
                },
            ],
        },
    ],
};

export default MOCK_LAYER_REVIEW;
